import type { ComponentType, ReactNode } from "react";

interface ActionListItemProps {
  children: ReactNode;
  icon: ComponentType<{ size?: number; className?: string }>;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  external?: boolean;
  disabled?: boolean;
  "data-testid"?: string;
}

function ActionListItem({ children, icon: Icon, onClick, href, external, disabled, ...props }: ActionListItemProps) {
  const className = "flex items-center gap-3 w-full bg-transparent border-0 p-0 text-foreground hover:text-accent transition-colors cursor-pointer disabled:opacity-50 disabled:pointer-events-none text-left";

  const content = (
    <>
      <Icon size={16} className="shrink-0 text-muted" />
      <span>{children}</span>
    </>
  );

  if (href) {
    return (
      <li className="px-4 py-3">
        <a
          className={className}
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noreferrer" : undefined}
          onClick={onClick}
          data-testid={props["data-testid"]}
        >
          {content}
        </a>
      </li>
    );
  }

  return (
    <li className="px-4 py-3">
      <button
        type="button"
        className={className}
        onClick={onClick}
        disabled={disabled}
        data-testid={props["data-testid"]}
      >
        {content}
      </button>
    </li>
  );
}

function ActionList({ children }: { children: ReactNode }) {
  return (
    <ul className="list-none p-0 m-0 panel-surface rounded-[10px] divide-y divide-line">
      {children}
    </ul>
  );
}

export { ActionList, ActionListItem };
